import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { SharedService } from '../../shared/service/shared.service';

@Injectable()
export class EmployerService {
	SITE_API_URL: any = '';
	data: any = {};
	// Define constructor
	constructor(public sharedService: SharedService) {
		this.SITE_API_URL		=	environment.API_URL;
	}

	/** This function are used for get the dashboard data.  */
	getEmployerData = (formData : any): any => {
		const methodName					=	'get_employer_dashboard';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data); 
	}

	getStripeurl = (formData : any): any => {
		const methodName					=	'create_session';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data); 
	}

	getStripeurlrepayment = (formData : any): any => {
		const methodName					=	'new_card';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data); 
	}


	/** This function are used to submit user profile.  */
	submitEmployerData = (formData : any): any => {
		const methodName					=	'edit_user_profile';
		const methodUrl						=	environment.API_URL + methodName;
		return this.sharedService.getPostImage(methodUrl, formData);
	}

	cancelsub = (formData : any): any => {
		const methodName					=	'subscription_cancel';
		const methodUrl						=	environment.API_URL + methodName;
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data); 

	}


	/** This function are used to get the master value.  */
	getDropdown = (formData : any): any => {
		const methodName					=	'get_master_value';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data);
	}

	/** This function are used to post the jobs.  */
	postJob = (formData : any): any => {
		const methodName					=	'post_job';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data); 
	}

	/** This function are used to manage jobs.  */
	manageJob = (formData : any): any => {
		const methodName					=	'manage_job_post';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data); 
	}

	/** This function are used to get the job details.  */
	getJobDetails = (formData : any): any => {
		const methodName					=	'get_job_details';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data);  
	}

	/** This function are used for get category dropdown.  */
	getParseResume = (formData : any): any => {
		const methodName					=	'parse_resume';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.parseResume(methodUrl, this.data);
	}
	/** This function are used for get category dropdown.  */
	
	/** This function are used to update the job details.  */
	updateJobDetails = (formData : any): any => {
		const methodName					=	'update_job_post';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data); 
	}
	
	/** This function are used for get category dropdown.  */
	getCategoryDropdown = (formData : any): any => {
		const methodName					=	'get_category_dropdown';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data);
	}


	sendmessage = (formData : any): any => {
		const methodName					=	'employer_chat';
		const methodUrl						=	environment.API_URL + methodName;
		// this.data							=	{};
		// this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, formData); 
	}
	

		/** This function are used for get category dropdown.  */


		getInvoicelist(formData: any): any {
			const methodName = 'invoice_list';
			const methodUrl = environment.API_URL + methodName; 
		  
			return this.sharedService.getPost(methodUrl, formData);
		  }
	

		  getChatuser(formData: any): any {
			const methodName = 'chat_user_names';
			const methodUrl = environment.API_URL + methodName; 
		  
			return this.sharedService.getPost(methodUrl, formData);
		  }
	


		  acceptinterview = (formData: any): any => {
			const methodName = 'accept_interview';
			const methodUrl = environment.API_URL + methodName;
			return this.sharedService.getPostImage(methodUrl, formData);
		  };
		  


		  getmessagelists = (formData : any): any => {
			const methodName					=	'employer_message_list';
			const methodUrl						=	environment.API_URL + methodName;
			this.data							=	{};
			this.data.data						=	formData;
			return this.sharedService.getPost(methodUrl, this.data);


		}

	/** This function are used for get subscription plan list */
	getSubscriptionPlan = (formData : any): any => {
		const methodName					=	'user_subscription_plan';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data);
	}

	/** This function are used for get jobseeker list */
	getJobseekerList = (formData : any): any => {
		const methodName					=	'get_job_seeker_list';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data);
	}
	/** This function are used for get subscription plan list */

	/** This function are used for get the jobs dropdown.  */
	getJobsDropdown = (formData : any): any => {
		const methodName					=	'get_job_dropdown';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data); 
	}
	/** This function are used for get the jobs dropdown.  */

	/** This function are used for get application list data */
	sendInvitations = (formData : any): any => {
		const methodName					=	'invite_jobseeker';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data);
	}
	/** This function are used for get application list data */

	/** This function are used for get subscription plan list */
	getApplicationList = (formData : any): any => {
		const methodName					=	'get_application_list';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data);
	}
	/** This function are used for get subscription plan list */

	/** This function are used for get apllication detail */
	getApplicationDetail = (formData : any): any => {
		const methodName					=	'get_application_details';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data);
	}
	/** This function are used for get apllication detail */

	/** This function are used for get change application status */
	changeStatus = (formData : any): any => {
		const methodName					=	'change_application_status';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data);
	}
	/** This function are used for get change application status */

	/** This function are used for get import job list */
	getImportJobList = (formData : any): any => {
		const methodName					=	'get_temp_job_list';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data);
	}
	/** This function are used for get import job list */

	/** This function are used to submit import jobs.  */
	submitImportJobData = (formData : any): any => {
		const methodName					=	'store_import_jobs';
		const methodUrl						=	environment.API_URL + methodName;
		return this.sharedService.getPostImage(methodUrl, formData);
	}
	
	/** This function are used to get import job details.  */
	getImportJobDetails = (formData : any): any => {
		const methodName					=	'get_temp_job_details';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data);  
	}

	/** This function are used to delete imported jobs.  */
	deleteImportJobDetails = (formData : any): any => {
		const methodName					=	'delete_imported_jobs';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data);  
	}

	/** This function are used for get the post imported jobs list.  */
	importJobPost = (formData : any): any => {
		const methodName					=	'post_imported_jobs';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data);  
	}

	/** This function are used for save draft post.  */
	saveDraftPostJob = (formData : any): any => {
		const methodName					=	'add_edit_draft_job';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data); 
	}
	/** This function are used for save draft post.  */

	
	/** This function are used for update draft podt  */
	updateDraftJobDetails = (formData : any): any => {
		const methodName					=	'add_edit_draft_job';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data); 
	}
	/** This function are used for update draft podt  */

	/** This function are used for get the draft list.  */
	draftManageJob = (formData : any): any => {
		const methodName					=	'get_draft_jobs';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data); 
	}

	/** This function are used for get draft job detail.  */
	getDraftJobDetails = (formData : any): any => {
		const methodName					=	'get_draft_job_detail';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data);  
	}

	/** This function are used to delete draft job.  */
	deletePostJobDetails = (formData : any): any => {
		const methodName					=	'delete_draft_job';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data);  
	}
	submitimageData = (formData: any): any => {
		const methodName = 'update_profile_image';
		const methodUrl = environment.API_URL + methodName;
		this.data = formData;
		return this.sharedService.getPost(methodUrl, this.data);
	  };
	

	livedraftjob = (formData : any): any => {
		const methodName					=	'live_draft_job';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data);  
	}


	triggerinichat = (formData : any): any => {
		const methodName					=	'create_chat';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data);  
	}


	changetoclosed = (formData : any): any => {
		const methodName					=	'job_closed';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data);  
	}


	/** This function are used for get multiple master value.  */
	getMultipleMasterValueDropdown = (formData : any): any => {
		const methodName					=	'get_multiple_master_value';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data);
	}	
}
